export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="hero--section--title">HEY, I'M RITIK SHARMA</p>

          <p className="hero--section--description">
            A Result-Oriented frontend Developer experienced in designing and
            implementing dynamic and visually appealing user interfaces.
          </p>
        </div>
      </div>
      <div className="hero--section--img">
        <img src="./img/Hero_img.png" alt="hero-section" />
      </div>
    </section>
  );
}
